module.exports = __webpack_public_path__ + "public/img/zyywhjxy.76d90323.png";